<template>
  <div class="select-row" style="display: flex; gap: 8px; margin-bottom: 8px">
    <Select
      v-model="localValue1"
      style="width: 120px"
      @on-change="handleChange"
      :clearable="false"
      :disabled="disabled"
      placeholder="请选择宿主名称"
    >
      <Option v-for="item in runtimeList" :value="item.value" :key="item.value">{{
        item.label
      }}</Option>
    </Select>
    <Select
      v-model="localValue2"
      style="width: 120px"
      @on-change="handleChange"
      :clearable="false"
      :disabled="disabled"
      placeholder="请选择条件"
    >
      <Option v-for="item in conditionList" :value="item.value" :key="item.value">{{
        item.label
      }}</Option>
    </Select>
    <Input
      v-model="localValue3"
      style="width: 120px"
      class="inputValue3"
      @input="handleVersionInput"
      placeholder="请输入宿主版本号"
      :disabled="disabled"
    />
    <Button :disabled="disabled" type="error" icon="ios-trash" @click="handleDelete" />
  </div>
</template>
<script>
export default {
  name: 'SelectRow',
  props: {
    packageName: {
      type: String,
      default: ''
    },
    condition: {
      type: String,
      default: ''
    },
    version: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      required: true
    },
    runtimeList: {
      type: Array,
      default: () => []
    },
    conditionList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue1: this.packageName,
      localValue2: this.condition,
      localValue3: this.version
    }
  },
  methods: {
    handleDelete () {
      this.$emit('delete', this.index)
    },
    handleChange () {
      this.$emit('change', {
        index: this.index,
        packageName: this.localValue1,
        condition: this.localValue2,
        version: this.localValue3
      })
    },
    handleVersionInput (value) {
      // 只允许数字和小数点
      // const newValue = value.replace(/[^0-9.]/g, '')
      // // 确保小数点只出现一次，并且不能以小数点开头
      // if (newValue.split('.').length <= 5 && !/^[\u4e00-\u9fa5a-zA-Z.]/.test(newValue)) {
      //   this.localValue3 = ''
      //   this.$nextTick(() => {
      //     this.localValue3 = newValue
      //     this.handleChange() // 同步数据到父组件
      //   })
      // }
      this.localValue3 = ''
      this.$nextTick(() => {
        this.localValue3 = value
        this.handleChange() // 同步数据到父组件
      })
    }
  },
  watch: {
    packageName (val) {
      this.localValue1 = val
    },
    condition (val) {
      this.localValue2 = val
    },
    version (val) {
      this.localValue3 = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/esApp/selectRow.vue